import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  width: 100%;
`

const TabList = styled.ul`
  list-style: none;
  display: flex;
`

const ActiveContent = styled.div`
  width: 100%;
`

class Tabs extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeTabIndex: this.props.defaultActiveTabIndex
    }
  }

  handleTabClick (tabIndex) {
    this.setState({
      activeTabIndex: tabIndex === this.state.activeTabIndex ? this.props.defaultActiveTabIndex : tabIndex
    })
  }

  // Encapsulate <Tabs/> component API as props for <Tab/> children
  renderChildrenWithTabsApiAsProps () {
    return this.props.children.map((child, index) => {
      return React.cloneElement(child, {
        onClick: this.handleTabClick.bind(this),
        tabIndex: index,
        isActive: index === this.state.activeTabIndex,
        key: index
      })
    })
  }

  // Render current active tab content
  renderActiveTabContent () {
    const { children } = this.props
    const { activeTabIndex } = this.state
    if (children[activeTabIndex]) {
      return children[activeTabIndex].props.children
    }
  }

  render () {
    return (
      <Wrapper>
        <TabList>
          {this.renderChildrenWithTabsApiAsProps()}
        </TabList>
        <ActiveContent>
          {this.renderActiveTabContent()}
        </ActiveContent>
      </Wrapper>
    )
  }
}

Tabs.propTypes = {
  defaultActiveTabIndex: PropTypes.number
}

Tabs.defaultProps = {
  defaultActiveTabIndex: 0
}

export default Tabs



// WEBPACK FOOTER //
// ./src/components/UI/Tabs/index.js